/// <amd-module name="VSSUI/Label" />
export { Label } from "./Components/Label/Label";
export { ILabelProps, ILabelModel } from "./Components/Label/Label.Props";
export { LabelGroup } from "./Components/LabelGroup/LabelGroup";
export { EditableLabelGroup } from "./Components/LabelGroup/EditableLabelGroup";
export { ILabelGroupProps, WrappingBehavior } from "./Components/LabelGroup/LabelGroup.Props";
